import * as RacesClient from '../clients/RacesClient'
import Race from './Race'

export default class RaceList {
  constructor() {
    this.races = []
    this.loaded = false
  }
  async load (date) {
    if (date) {
      var races = await RacesClient.getRaces(date)
      this.date = date
      for (var i = 0; i < races.length; i++) {
        this.races.push(new Race(races[i]))
      }
      this.races = this.races.sort((a,b) => {
        return (b.location + b.time > a.location + a.time)? -1 : (b.location + b.time > a.location + a.time)? 1 : 0
      })
      this.loaded = true
    }
  }
}
